import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Save } from 'lucide-react';

export function CreateComplaintPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    shipmentNumber: '',
    customerName: '',
    subject: '',
    description: '',
    priority: 'Medium'
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Complaint Data:', formData);
    navigate('/complaints');
  };

  return (
    <div className="space-y-6" dir="rtl">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate('/complaints')} className="p-2 hover:bg-gray-100 rounded-lg">
          <ArrowRight size={20} />
        </button>
        <h1 className="text-2xl font-bold text-gray-900">تسجيل شكوى جديدة</h1>
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">رقم الشحنة (إن وجد)</label>
              <input type="text" className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white" value={formData.shipmentNumber} onChange={e => setFormData({...formData, shipmentNumber: e.target.value})} />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">اسم الشاكي / العميل *</label>
              <input type="text" required className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white" value={formData.customerName} onChange={e => setFormData({...formData, customerName: e.target.value})} />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">موضوع الشكوى الرئيسي *</label>
              <input type="text" required className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white" value={formData.subject} onChange={e => setFormData({...formData, subject: e.target.value})} />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">درجة الأهمية / الخطورة</label>
              <select className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white" value={formData.priority} onChange={e => setFormData({...formData, priority: e.target.value})}>
                <option value="Low">منخفضة</option>
                <option value="Medium">متوسطة</option>
                <option value="High">عالية جداً / عاجلة</option>
              </select>
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">تفاصيل الشكوى بالكامل *</label>
              <textarea rows={4} required className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white" value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} />
            </div>
          </div>
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3">
          <button type="button" onClick={() => navigate('/complaints')} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg">إلغاء</button>
          <button type="submit" className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded-lg">
            <Save size={16} /> تقديم الشكوى
          </button>
        </div>
      </form>
    </div>
  );
}
